import { Schema as S } from "effect";

export const UpdatePatientRequestSchema = S.Struct({
  _id: S.String,
});

export type UpdatePatientRequest = S.Schema.Type<typeof UpdatePatientRequestSchema>;
